module.exports = __webpack_public_path__ + "static/big-logo-1195fd270c639f70feb9f4eb5fc70137.png";